import "./hope-admission-section-table-code-row.scss";

import { bindable, bindingMode, computedFrom, containerless, customElement } from "aurelia-framework";
import { IHopeAdmissionFormSectionTableRootCode } from "../../../../../interfaces/i-hope-center";
import nameof from "../../../../../common/nameof";

@containerless
@customElement("hope-admission-section-table-code-row")
export class HopeAdmissionSectionTableCodeRow {
    @bindable({ defaultBindingMode: bindingMode.toView })
    public codeData: any;
    @bindable({ defaultBindingMode: bindingMode.fromView })
    public replaceAnswer?: (args: { sourceIds: string[] }) => Promise<void>;
    @bindable({ defaultBindingMode: bindingMode.toView })
    public isSelected: boolean = false;
    @bindable({ defaultBindingMode: bindingMode.toView })
    public childLevel: number = 0;
    @bindable({ defaultBindingMode: bindingMode.toView })
    public hasViewPermission: boolean;
    @bindable({ defaultBindingMode: bindingMode.toView })
    public hasEditPermission: boolean;
    public isReplacing: boolean = false;

    @computedFrom(
        nameof<HopeAdmissionSectionTableCodeRow>("isSelected"),
        `${nameof<HopeAdmissionSectionTableCodeRow>("codeData")}.${nameof<IHopeAdmissionFormSectionTableRootCode>(
            "isSelected"
        )}`
    )
    public get isGroupSelected() {
        return this.codeData?.isSelected ?? this.isSelected;
    }

    @computedFrom(nameof<HopeAdmissionSectionTableCodeRow>("childLevel"))
    public get indent() {
        return Math.min(this.childLevel, 5);
    }

    public async replace() {
        try {
            this.isReplacing = true;
            await this.replaceAnswer({ sourceIds: this.codeData.sourceIds });
        } catch (e) {
            console.error(e);
        } finally {
            this.isReplacing = false;
        }
    }
}
